<template>
  <transition name="fade">
    <div
      v-if="modelValue"
      @click.self="emit('update:modelValue', false)"
      class="fixed inset-0 bg-black/50 z-40 cursor-pointer hover:opacity-80 transition-opacity duration-300"
    ></div>
  </transition>

  <transition name="slidein">
    <div
      v-if="modelValue"
      :class="[
        'flex flex-col w-[90vw] max-w-132 fixed right-0 top-0 bottom-0 shadow-xl overflow-auto bg-surface-light z-50',
        props.class,
      ]"
    >
      <div
        class="flex items-center justify-between sticky top-0 border-b border-surface-grey px-6 py-4 text-lg font-semibold bg-surface-light z-10"
      >
        {{ title }}
        <button
          @click="handleClose"
          type="button"
          class="cursor-pointer hover:opacity-50"
          :title="$t('common.close')"
        >
          <CloseIcon class="h-6 w-6" />
        </button>
      </div>
      <div class="mb-2">
        <slot name="belowHeader" />
      </div>
      <div class="p-6 mb-4 grow overflow-y-auto">
        <slot />
      </div>

      <div v-if="$slots.footer" class="p-6 border-t border-surface-grey">
        <slot name="footer" />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import { onBeforeUnmount,onMounted } from 'vue';

  import CloseIcon from '@/components/icons/CloseIcon.vue';

  const props = defineProps<{
    modelValue: boolean;
    title: string;
    class?: string;
  }>();
  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
  }>();

  const handleClose = () => {
    emit('update:modelValue', false);
  };

  onMounted(() => {
    window.addEventListener('keydown', onEscClose);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('keydown', onEscClose);
  });

  function onEscClose(e: KeyboardEvent) {
    if (e.key === 'Escape' && props.modelValue) {
      emit('update:modelValue', false);
    }
  }
</script>
